// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f693cec1","453":"8307d1f9","455":"c7100191"}[chunkId] + ".chunk.js";
};